import { AssetChangeReason } from 'enums';
import { AssetBalanceHistory } from 'types';

export const getAssetBalanceHistoryCurrencyRate = (
  item: AssetBalanceHistory,
) => {
  if (item.currencyRate != null) return item.currencyRate;

  // Legacy trader principal/release rows have no reliable historical rate.
  // The current order may belong to a different trader after reassignment.
  if (
    item.payoutOrder &&
    !item.asset?.shopId &&
    !item.asset?.shopGroupId &&
    [
      AssetChangeReason.CompleteOrder,
      AssetChangeReason.CancelOrder,
      AssetChangeReason.ReleasePayoutOrderHold,
    ].includes(item.assetChangeReason)
  )
    return undefined;

  return (item.order || item.payoutOrder)?.currencyRate;
};
